import { render } from "./ExportExcel.vue?vue&type=template&id=22742140"
import script from "./ExportExcel.vue?vue&type=script&lang=js"
export * from "./ExportExcel.vue?vue&type=script&lang=js"
script.render = render

export default script